<template>
  <notification-base-list
  :enable-send-notification="true"
  :extra-list-params="ExtraListParams"
  :extra-columns="ExtraColumns"
  :extra-filter-options="ExtraFilterOptions"
  :id="id"
  v-on:send="openSendDialog" />
</template>

<script>
import NotificationBaseList from '@IAM/sections/NotificationBaseList'
import WindowsMixin from '@/mixins/windows'
import { getTimeRangeFilter } from '@/utils/common/tableFilter'
import { getTimeTableColumn } from '@/utils/common/tableColumn'
import { NOTIFY_TOPIC_TYPES_MAP } from '@IAM/constants'
import { NOTIFICATION_SEND_TYPE } from '@/constants/notification'

export default {
  name: 'NotificationList',
  components: {
    NotificationBaseList,
  },
  mixins: [WindowsMixin],
  props: {
    id: String,
  },
  data () {
    return {
      ExtraListParams: { contact_type: 'webconsole' },
      ExtraColumns: [
        {
          // 消息类型
          title: this.$t('system.notify.topic.type'),
          field: 'topic_type',
          sortable: true,
          minWidth: 100,
          showOverflow: 'title',
          formatter: ({ row }) => {
            return NOTIFY_TOPIC_TYPES_MAP[row.topic_type] ? NOTIFY_TOPIC_TYPES_MAP[row.topic_type].label : '-'
          },
        },
        getTimeTableColumn({
          field: 'received_at',
          title: this.$t('system.text_316'), // 接收时间
        }),
        {
          // 内容
          title: this.$t('system.text_308'),
          field: 'content',
        },
      ],
      ExtraFilterOptions: {
        // topic_type: {
        //   label: this.$t('system.text_48'),
        //   filter: true,
        //   dropdown: true,
        //   distinctField: {
        //     type: 'field',
        //     key: 'topic_type',
        //     getParams: this.getParam,
        //   },
        //   formatter: val => {
        //     return `topic_type.contains("${val}")`
        //   },
        //   mapper: list => {
        //     return list.map(({ key, label }) => {
        //       return {
        //         key,
        //         label: NOTIFY_TOPIC_TYPES_MAP[key] ? NOTIFY_TOPIC_TYPES_MAP[key].label : label,
        //       }
        //     })
        //   },
        // },
        received_at: getTimeRangeFilter({ label: this.$t('system.text_316'), field: 'received_at' }),
      },
    }
  },
  methods: {
    openSendDialog () {
      this.createDialog('MessageSendDialog', {
        title: this.$t('system.text_592'), // 发送消息
        onSend: async (data) => {
          const finalData = {
            ...data,
            contact_type: 'webconsole',
            ignore_nonexistent_user: true,
          }
          if (finalData.topic_type === NOTIFICATION_SEND_TYPE.announcement) {
            await this.$http.post('/v1/announcements', finalData)
            return
          }
          await this.$http.post('/v1/notifications', finalData)
        },
      })
    },
  },
}
</script>
